import { makeStyles } from 'lib/components';

export default makeStyles(() => ({
  mainPaper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: '16px',
    '@media (min-width: 640px)': {
      margin: '16px 24px',
      padding: '24px',
    },
  },
  detailsMapGrid: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    height: 'fit-content',
    flexWrap: 'wrap',
    gap: '16px',
    '@media (min-width: 640px)': {
      gap: '24px',
    },
  },
  message: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
  },
  saveReportBtn: {
    '&:disabled': {
      backgroundColor: '#007CAD',
    },
    padding: '10px 16px',
  },
  linksAndBtn: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 24px',
    '@media (min-width:640px)': {
      padding: 0,
      alignItems: 'flex-start',
    },
  },
  warningAlert: {
    borderBottom: '0px !important',
    borderRadius: '4px',
  },
  button: {
    height: '44px',
  },
  topImage: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    '@media (min-width: 640px)': {
      width: 'unset',
      maxWidth: '100%',
      maxHeight: '400px',
    },
  },
}));
